var hooxShopSection = document.querySelector('.hoox-shop');

//GALLERY HANDLER ON MOB
if (window.innerWidth < 992) {
  function handleGalleryOnMob() {
      var shopGallery = document.querySelector('.hoox-shop__gallery.mobile-swap-position');
      if (shopGallery) {
        var galleryInnerHTML = shopGallery.innerHTML;
        shopGallery.remove();

        var shopGalleryContainerMob = document.querySelector('.hoox-shop__gallery-container-mob');
        shopGalleryContainerMob.querySelector('.hoox-shop__gallery').innerHTML = galleryInnerHTML;
      }
  }

  handleGalleryOnMob();
}

// SHOP GALLERY
var shopGallery = hooxShopSection.querySelector('.hoox-shop__gallery');

if (shopGallery) {
    var shopGalleryThumbs = shopGallery.querySelectorAll('.hoox-shop__gallery-thumbs .swiper-slide');
    const slidesCount = shopGallery.dataset.slidesCount;
    if (shopGalleryThumbs.length > 0) {
        var galleryThumbs = new Swiper('.swiper-thumbs', {
            slidesPerView: slidesCount,
            spaceBetween: 10,
            watchSlidesProgress: true,

            breakpoints: {
                768: {
                    spaceBetween: 15,
                },
            },
        });

        var galleryTop = new Swiper('.swiper-main', {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
}

//ACCORDIONS
const accordionsHolder = hooxShopSection.querySelector('.hoox-shop__accordions');

if (accordionsHolder) {
    const accordions = accordionsHolder.querySelectorAll('.hoox-shop__accordion');

    accordions.forEach(accordion => {
        const accordionBtn = accordion.querySelector('.hoox-shop__accordion-header');
        const accordionBody = accordion.querySelector('.hoox-shop__accordion-body');

        var accordionBodyHeightValue;

        if(accordionBody.scrollHeight > 200) {
            if(window.innerWidth < 768) {
                accordionBodyHeightValue = 200;
            } else {
                accordionBodyHeightValue = 160;
            }
            accordion.classList.remove('remove-shadow');
        } else {
            accordionBodyHeightValue = accordionBody.scrollHeight;
            accordion.classList.add('remove-shadow');
        }

        !accordion.classList.contains('show-text')
         ? accordionBody.style.maxHeight = null
         : accordionBody.style.maxHeight = accordionBodyHeightValue + 'px';

        accordionBtn.addEventListener('click', () => {
            accordion.classList.toggle('show-text');
            accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
            !accordion.classList.contains('show-text')
             ? accordionBody.style.maxHeight = null
             : accordionBody.style.maxHeight = accordionBodyHeightValue + 'px';
        });
    })
}

// POPUP TOGGLE
var popupTriggers = hooxShopSection.querySelectorAll(".js-popup-toggle-button");
var popup = hooxShopSection.querySelector(".hoox-shop-popup");
var html = document.querySelector("html");

if (popup) {
    setTimeout(function () {
        popup.style.display = "flex";
    }, 3000);
    popupTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
            popup.classList.toggle("active");
            html.classList.toggle("scroll-hidden");
        });
    });
}

//APPEND PRICE PER DAY FOR PURCHASE PLANS
function getValue(name) {
    return hooxShopSection.querySelector(`input[name="${name}"]`).value;
}

var pricePerdayText = getValue("price-per-day");
var threeMonthPlan = getValue("3-month");
var oneMonthPlan = getValue("1-month");
var oneTimePlan = getValue("one-time");

var purchaseOptionOneTime = hooxShopSection.querySelector('.c-product-purchase__type--one-time-purchase');
var purchaseOptionOneMonth = hooxShopSection.querySelector('.c-product-purchase__type--subscription');
var purchaseOptionThreeMonth = hooxShopSection.querySelector('.c-product-purchase__type--subscription--quarterly');

function createAndAppendPriceElement(target, text, value) {
    var element = document.createElement("div");
    element.innerHTML = `<span class='price-text'>${text}</span> <span class='price-value'>${value}</span>`;
    target.querySelector(".c-product-purchase__details").appendChild(element);
    element.classList.add("hoox-shop__price-per-day");
}

createAndAppendPriceElement(purchaseOptionThreeMonth, pricePerdayText, threeMonthPlan);
createAndAppendPriceElement(purchaseOptionOneMonth, pricePerdayText, oneMonthPlan);
createAndAppendPriceElement(purchaseOptionOneTime, pricePerdayText, oneTimePlan);

//3 MONTH PLAN PRICE HANDLE
var threeMonthPlanBox = hooxShopSection.querySelector('.c-product-purchase__type--subscription--quarterly');
var threeMonthPlanPrice = hooxShopSection.querySelector('.c-product-purchase__type--subscription--quarterly .c-product-purchase__price').innerHTML?.trim();
var shopAtcBbuttonPriceSpan = hooxShopSection.querySelector('button[data-add-to-cart] span[data-product-price]');
console.log(threeMonthPlanPrice);
console.log(shopAtcBbuttonPriceSpan);

threeMonthPlanBox.addEventListener('click', function() {
    shopAtcBbuttonPriceSpan.innerHTML = `&mdash;&nbsp;${threeMonthPlanPrice}`;
});

